module.exports = __webpack_public_path__ + "static/block-column-image-2-590da94789b34a5269844c7db42db8bc.png";